<template>
  <v-container grid-list-xl>
    <v-layout wrap>

        <v-dialog v-model="loading" fullscreen full-width>
          <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
            <v-layout justify-center align-center>
              <v-progress-circular
                indeterminate
                color="primary">
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>

        <v-flex xs12>
           <v-alert type="success" dismissible v-model="alert1">
                {{ message }}
           </v-alert>
           <v-alert type="error" dismissible v-model="alert2">
                {{ error }}
           </v-alert>
        </v-flex>

      <v-flex xs12 class="text-center">
        <h1>My FLLI Feedback Form</h1>
      </v-flex>

      <v-flex xs12 sm6 offset-sm3>
        <form @submit.prevent="submitFeedback">
          <v-layout column>

            <v-flex>
              <p>Please provide your feedback to the Avyance Development Team so we can improve future versions of MyFLLI.</p>
              <p>Overall how would you rate MyFLLI?</p>
              <v-select
                name="rate"
                v-model="rate"
                :items="rateOptions"
                label="Rate us"
              ></v-select>
            </v-flex>

            <v-flex>
              <p>What features did you like most? Least? What changes would you suggest? </p>
              <v-textarea
                name="suggestion"
                label="Your comments / suggestions"
                v-model="suggestion"
                hint="Provide your feedback here"
              ></v-textarea>              
            </v-flex>

            <v-flex>
              <p>Provide your contact information in case we have questions based on your feedback.</p>
              <v-text-field
                name="full_name"
                label="Your Name"
                id="full_name"
                type="text"
                v-model="full_name"
                required></v-text-field>
            </v-flex>

            <v-flex>
              <v-text-field
                name="email"
                label="Your Email"
                id="email"
                type="email"
                v-model="email"
                required></v-text-field>
            </v-flex>

            <v-flex class="text-center">
              <v-btn color="primary" type="submit" :disabled="loading">Submit Your Feedback</v-btn>
            </v-flex>

          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      rate: '',
      email: '',
      suggestion: '',
      full_name: '',
      alert1: false,
      alert2: false,
      rateOptions: ["", "Excellent", "Good", "Fair", "Poor"]
     }
  },
  computed: {
    error () {
      return this.$store.state.error
    },
    message () {
      return this.$store.state.message
    },
    loading () {
      return this.$store.state.loading
    }
  },
  methods: {
    submitFeedback () {
      this.$store.dispatch('submitFeedback', {
        email: this.email,
        full_name: this.full_name,
        suggestion: this.suggestion,
        rate: this.rate
      })
    }
  },
  mounted() {
    if(this.$store.state.userProfile != null)
    {
      this.full_name = this.$store.state.userProfile.first_name + ' ' + this.$store.state.userProfile.last_name
      this.email = this.$store.state.loggedUser.email
    }
  },
  watch: {
    error (value) {
      if (value) {
        this.alert2 = true
      }
    },
    alert2 (value) {
      if (!value) {
        this.$store.commit('setError', null)
      }
    },
    message (value) {
      if (value) {
        this.alert1 = true
      }
    },
    alert1 (value) {
      if (!value) {
        this.$store.commit('setMessage', null)
      }
    }
  }
}</script>